import React, { useRef } from 'react';
import { Dialog, DialogTitle } from '.';
import { DialogContent } from '../dialogs';
import { Button, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { CodeLoginForm } from '../../forms/user/code-login/code-login.form';
import { IZone } from '../../models';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../consts';

interface EmployeeLoginDialogProps {
  visible: boolean;
  onClose: () => void;
  zone: IZone;
}
export const EmployeeLoginDialog = (props: EmployeeLoginDialogProps) => {
  const { zone, visible = false, onClose = () => {} } = props;
  const form = useRef<any>();
  const navigate = useNavigate();

  const handleSubmit = () => {
    form.current.onSubmit();
  };

  const handleLoginSuccess = () => {
    // close modal
    onClose();
    // navigate to employee page
    navigate(`/code/${ROUTES.CODE_EMPLOYEE_ACCESS.replace(':code', zone.code)}`);
  };

  return (
    <Dialog open={visible}>
      <DialogTitle sx={{ textAlign: 'center' }}>
        <Typography color="primary" style={{ fontWeight: 'bold', fontSize: 18 }}>
          Employee Access
        </Typography>
      </DialogTitle>
      <DialogContent>
        <CodeLoginForm ref={form} zone={zone} next={handleLoginSuccess} />

        <Button variant="contained" onClick={handleSubmit}>
          Login
        </Button>

        <Button startIcon={<ArrowBackIcon />} sx={{ mt: 2 }} onClick={onClose} fullWidth>
          Go Back
        </Button>
      </DialogContent>
    </Dialog>
  );
};
